import { render, staticRenderFns } from "./VouchersForm.vue?vue&type=template&id=54bdcee4"
import script from "./VouchersForm.vue?vue&type=script&lang=js"
export * from "./VouchersForm.vue?vue&type=script&lang=js"
import style0 from "./VouchersForm.vue?vue&type=style&index=0&id=54bdcee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports